import React from 'react';
import { openNewWindow, setDash, setDetailPageUrl, setPhoneFormat, setNumberWithComma } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import Anchor from '../../../../components/link/Anchor';
import SendMessageService from '../../../../containers/app/common/SendMessageService';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import {
  ACCOUNT_USER_DETAIL_TAB_KEY,
  ACCOUNT_USER_STATUS_TEXT,
} from '../../../../constants/service/app/accountUserConstants';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { ACCOUNT_USER_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';

/**
 *  포인트 리스트 컬럼
 */
const columns = (data) => {
  const { list, sortOption } = data;
  return [
    {
      title: <TableColumnTitle title={'회원 번호'} />,
      dataIndex: 'userId',
      sorter: true,
      sortOrder: sortOption['userId'],
      render: (value) => (
        <Anchor
          color="primary"
          isUnderLine
          text={value}
          onClick={() =>
            openNewWindow(
              setDetailPageUrl(ACCOUNT_USER_DETAIL_URL_PATH, value) +
                `?tabKey=${ACCOUNT_USER_DETAIL_TAB_KEY.POINT_INFO}`,
            )
          }
        />
      ),
    },
    {
      dataIndex: 'name',
      title: <TableColumnTitle title={'이름'} />,
      render: (value) => setDash(value),
    },
    {
      dataIndex: 'cellPhone',
      title: <TableColumnTitle title={'휴대전화 번호'} />,
      render: (value, record, index) => (
        <SendMessageService
          text={setPhoneFormat(value)}
          memberType={AMONDZ_MEMBER_TYPE.USER}
          targetId={list[index].userId}
        />
      ),
    },
    {
      dataIndex: 'account',
      title: <TableColumnTitle title={'ID'} />,
      render: (value) => value,
    },
    {
      dataIndex: 'pointAmount',
      title: <TableColumnTitle title={'사용 가능한 포인트'} />,
      sorter: true,
      sortOrder: sortOption['pointAmount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      dataIndex: 'usedPointAmount',
      title: <TableColumnTitle title={'사용한 포인트'} />,
      sorter: true,
      sortOrder: sortOption['usedPointAmount'],
      render: (value) => setNumberWithComma(value),
    },
    {
      dataIndex: 'status',
      title: <TableColumnTitle title={'상태'} />,
      render: (value) => ACCOUNT_USER_STATUS_TEXT[value],
    },
    {
      dataIndex: 'createDate',
      title: <TableColumnTitle title={'가입일자'} />,
      sorter: true,
      sortOrder: sortOption['createDate'],
      render: (value) => setDateFormat(value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
